import { ErrorHandler, Injectable, isDevMode } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';


@Injectable()
export class GlobalExceptionFilter implements ErrorHandler {
  constructor() {}

  handleError(error: Error | HttpErrorResponse): void {
    // Si el error es un HttpErrorResponse, no lo maneja en este filtro global
    if (error instanceof HttpErrorResponse) {
      return;
    }

    const errorMessage = `Application Error: ${error.message}`;

    // Registrar el error de la aplicación en Datadog o cualquier otro servicio de logs
    
    // Opcional: mostrar el error en la consola en modo desarrollo
    if (isDevMode()) {
      console.error('Error captured by GlobalExceptionFilter:', error);
    }
  }
}
